export { TrustedShopsIcon } from './TrustedShops';
